const initial = {
  ordersData: {},
  orderLevelDetail: {},
  success: '',
  failure: '',
  eligiblePickItem: {},
  quickLinkList: []
};

export default function ordersData(state = initial, action) {
  switch (action.type) {
    case 'GET_USER_ORDERS_DATA':
      return { ...state, ordersData: action.ordersData };

    case 'GET_ORDER_LEVEL_DATA':
      return { ...state, orderLevelDetail: action.orderLevelDetail };

    case 'GET_ORDER_SUCCESS':
      return { ...state, success: action.success, message: action.message || '' };

    case 'SET_FAILURE': {
      return { ...state, failure: action.failure, message: action.message || '' };
    }
    case 'SET_ELIGIBLE_PICK_ITEMS': {
      return { ...state, eligiblePickItem: action.data };
    }

    case 'ACCOUNY_PAGE_RENDER':
      return { ...state };

    case 'SET_IMPS_DATA':
      return { ...state, impsResObj: action.impsResObj };

    case 'CLAWBACK_BANK_DISCOUNT':
      const { cacheKey, refundType } = action.meta || {};
      const bucket =
        refundType === 'RETURN_REFUND'
          ? 'clawbackBankDiscountReturnAmount'
          : 'clawbackBankDiscountCancelAmount';
      return {
        ...state,
        orderLevelDetail: {
          ...state.orderLevelDetail,
          [bucket]: {
            ...(state.orderLevelDetail?.[bucket] || {}),
            [cacheKey]: action.payload
          }
        }
      };

    case 'GET_QUICK_LINK_LIST':
      return { ...state, quickLinkList: action.payload };

    default:
      return state;
  }
}
